import React from 'react'
import PageHeader from "../components/PageHeader";
import { sansthanImg } from "../assets/assets.js";
import "../css/commontemplate.css";

export const Parampra = () => {
    return (
        <>  
          
            <PageHeader title="सर्व परंपरा" path="/about-goshala" name=" goshala" />
            {/* <Initiatives /> */}

            <div className="comman-template-section">
              
                
              <div className="comman-template-container">
                {/* container  */}
                <div className="comman-template-sub-section">
                  {/* sub-section */}
                  <div className="comman-template-img-container">
                   
                    <img
                      className="comman-template-image"
                      src={sansthanImg.parampara}
                      alt=""
                    />
                  </div>
                  <div className="comman-template-info-container">
                    {/* info container */}
                     {/* <h3>गोसेवेचे महत्त्व</h3> */}
                    <div className="comman-template-info-container-shlok">
                    यस्य नि:श्वसितं वेदा यो वेदेभ्योऽखिलं जगत् । <br />
                    निर्ममे तमहं वन्दे विद्यातीर्थं महेश्वरम् ॥
                      </div>
                    <p>
                    &nbsp;  &nbsp;  &nbsp; &nbsp;   &nbsp; &nbsp; नित्य प्रातःकाळी महाभिषेक पूजेच्या समयी अनेक वैदिक ब्रम्हवृंदांच्या उपस्थितीत महापूजा संपन्न होते. श्रींचे उत्सव, सणवार अथवा प्रसंगानुरूप रुद्रअभिषेक, रूद्र एकादशनी, महारुद्रअभिषेक, पवमान अभिषेक इत्यादी. याप्रमाणे अभिषेक सेवा संपन्न होते.
                    </p>
                  </div>
                </div>

                
      
                <div className="comman-template-sub-section"></div>
              </div>
            </div>
        </>
    );
}
